
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.524 5.521v.221c.395.49.555 1.127.439 1.743l-1.66 5.127A2.194 2.194 0 0112.259 14H2.155C.966 13.975.013 13.022 0 11.847v-8.89C0 1.34 1.316.023 2.953 0h3.432C7.487 0 8.38.883 8.38 1.972c0 .435.358.789.799.789h3.591c1.527.021 2.754 1.25 2.754 2.76zM2.954 1.183c-.993 0-1.797.795-1.797 1.775v5.616l.854-2.193a2.194 2.194 0 012.06-1.42h9.777c.138-.012.277-.012.415 0a1.596 1.596 0 00-1.493-1.017H9.18a1.992 1.992 0 01-1.996-1.972.793.793 0 00-.798-.789H2.953z","fill":"#7B01B5"}})])
          )
        }
      }
    